import {
    SERPRegionRequestDtoSortByPref,
    SPHotelInfoShort,
    SPHotelPage,
    SPSearchResp,
    TOrgConfig,
} from '@eventr/common'
import { IIpInfoState, ItemOptions } from '@eventr/common-storybook'

export enum defaultCurrencies {
    EUR = 'EUR',
    GBP = 'GBP',
    USD = 'USD',
}

export const defaultCurrenciesList: {
    key: string
    value: string
}[] = Object.entries(defaultCurrencies).map(([key, value]) => ({
    key,
    value,
}))

export type TFiltersObj = {
    starRating: number
    priceRange: [number, number]
    userRatingRange: [number, number]
    currency: defaultCurrencies
}

export type THotelRoom = {
    adults: number
    children: number[] /// Ages of each child (under 18)
}

export type TReturnReservationObj = {
    confirm?: string
    email?: string
    selectedItinerary?: {
        id: number
        label: string
    }
    justReturned: boolean
}

interface IBookingSliceState {
    bookingLoading: boolean
    showBookingService: boolean
    advertData: {
        SPHotelInfoShort: SPHotelInfoShort[]
        timeOfLastReq: number
    } | null
    destination: ItemOptions | null
    dateRange: [string | null, string | null]
    rooms: THotelRoom[]
    sortByPreference: SERPRegionRequestDtoSortByPref
    filtersObj: TFiltersObj
    searchResp: SPSearchResp | null
    selectedHotel: string | null
    provider: string | null
    hotelResp: SPHotelPage | null
    returnReservationObj: TReturnReservationObj | null
}

interface IBookingSliceActions {
    setBookingLoading: (set: boolean) => void
    setShowBookingService: (orgConfig: TOrgConfig) => void
    getAdvertData: (location: [number, number]) => Promise<void>
    setDestination: (destination: ItemOptions | null) => void
    setDateRange: (dateRange: [string | null, string | null]) => void
    setRooms: (rooms: THotelRoom[]) => void
    getDestinationOptions: (
        search: string,
        selectedEventInfo: any
    ) => Promise<ItemOptions[]>
    setSortByPreference: (
        sortByPreference: SERPRegionRequestDtoSortByPref
    ) => void
    setFiltersObj: (filterObj: TFiltersObj) => void
    clearFilterObj: () => void
    setSearchResp: (searchResp: SPSearchResp | null) => void
    onEnterBookPage: (selectedEventInfo: any, ipInfo: IIpInfoState) => void
    setSelectedHotel: (selectedHotel: string | null, provider: string) => void
    searchHotel: () => void
    loadMoreHotels: () => Promise<void>
    initialSearchHotels: (showErrors?: boolean) => Promise<void>
    setReturnReservationObj: (obj: TReturnReservationObj) => void
    handleAddReservation: (
        selectedOrg: string,
        onSuccess: () => void
    ) => Promise<void>
}

export const bookingSliceDefaults: IBookingSliceState = {
    bookingLoading: false,
    showBookingService: false,
    advertData: null,
    destination: null,
    dateRange: [null, null],
    rooms: [{ adults: 1, children: [] }],
    sortByPreference: 'recommendedAsc',
    filtersObj: {
        priceRange: [0, 1000],
        currency: defaultCurrencies.USD,
        userRatingRange: [1, 10],
        starRating: 5,
    },
    searchResp: null,
    selectedHotel: null,
    provider: null,
    hotelResp: null,
    returnReservationObj: null,
}

export interface IBookingSlice
    extends IBookingSliceState,
    IBookingSliceActions { }
